import React, { useEffect } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Errors from '../common/Errors';
import Row from '../common/Row';
import Select from '../common/Select';
import { MarkedEditor } from '../common/Marked';
import TimeStamp from '../common/TimeStamp';
import { handleFieldsetEdit } from './constants/handleFieldset';
import Icon from '../common/Icon';

const FieldsetEdit = (props) => {
  const { fieldset, toggleEdit, setFieldset, form } = props;
  const { created_at, updated_at, id, ...editableFields } = fieldset;
  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    getValues,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: { ...editableFields },
    criteriaMode: 'all',
  });
  const { dirtyFields, isDirty } = useFormState({ control });

  useEffect(() => {
    if (watch('conditional_text') === '') {
      setValue('conditional_type', null, { shouldDirty: true });
    } else if (dirtyFields.conditional_text && !watch('conditional_type')) {
      setValue('conditional_type', 'checkbox', { shouldDirty: true });
    }
  }, [watch('conditional_text'), watch('conditional_type')]);

  const onSubmit = async (formData) => {
    if (isDirty) {
      let editedFieldset = await handleFieldsetEdit(formData, fieldset.id);
      if (editedFieldset.ok) {
        setFieldset(editedFieldset.data);
        toggleEdit();
      } else if (editedFieldset.errors) {
        Object.entries(editedFieldset.errors).forEach(([key, message]) =>
          setError(key, { types: { [key]: message } })
        );
      }
    } else {
      toggleEdit();
    }
  };

  return (
    <>
      <div className='details'>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className='controls lower'>
            <button type='submit'>
              Save
              <Icon icon='save' />
            </button>
            <button className='cancel blue' onClick={toggleEdit}>
              Cancel
              <Icon icon='xmark' />
            </button>
          </div>
          <Row name='Display Name:'>
            <input {...register('display_name')} />
          </Row>
          <Row name='Name:'>
            <input
              {...register('name', {
                required: 'Required',
              })}
            />
            <ErrorMessage
              errors={errors}
              name='name'
              render={({ messages }) => <Errors messages={messages} />}
            />
          </Row>
          <Row name='Comment:'>
            <input {...register('comment')} />
          </Row>
          <Row name='Description:'>
            <MarkedEditor
              register={{ ...register('description') }}
              text={fieldset.description}
              getValues={() => getValues('description')}
            />
          </Row>
          <Row name='Conditional Text:'>
            <input {...register('conditional_text')} />
          </Row>
          {watch('conditional_text') && (
            <Row name='Conditional Type:'>
              <Select
                content={[
                  { value: 'checkbox', label: 'Checkbox' },
                  { value: 'radio', label: 'Radio' },
                ]}
                register={{
                  ...register('conditional_type', { shouldUnregister: true }),
                }}
              />
              <i style={{ marginLeft: '10px' }}>
                Delete 'Conditional Text' if normal fieldset is desired.
              </i>
            </Row>
          )}

          <TimeStamp title='Created' value={created_at} />
          <TimeStamp title='Updated' value={updated_at} />

          <Row name='Form:'>
            <a href={`/manage/forms/${form.id}`}>{form.name}</a>
          </Row>
        </form>
      </div>
    </>
  );
};

export default FieldsetEdit;
